// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator employees`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import locations from 'modules/locations/store/collections/locations'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* subscriptions manually fetched by 2 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 7 cases in this module */,
    [companyHolidays, {}] /* Referenced by 12 cases in this module */,
    [contractVersions, {}] /* Referenced by 3 cases in this module */,
    [employeeGroups, {}] /* Referenced by 8 cases in this module */,
    [employees, {}] /* Referenced by 82 cases in this module */,
    [features, {}] /* Referenced by 60 cases in this module */,
    [legalEntities, {}] /* Referenced by 9 cases in this module */,
    [locations, {}] /* Referenced by 3 cases in this module */,
    [memberships, {}] /* Referenced by 4 cases in this module */,
    [subscriptions, {}] /* Referenced by 5 cases in this module */,
    [teams, {}] /* Referenced by 6 cases in this module */,
    [timeoffPolicies, {}] /* Referenced by 5 cases in this module */,
    [users, {}] /* Referenced by 50 cases in this module */,
  ] /* Generated file 👉 artifacts/employees-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
